import type { HTMLAttributes } from 'react';

export type PageSidebarProps = HTMLAttributes<HTMLDivElement>;

export const PageSidebar = ({ children, ...props }: PageSidebarProps) => {
	return (
		<div className="page-sidebar" {...props}>
			{children}
		</div>
	);
};

export default PageSidebar;
